// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"bf43e65b","209":"c28c0990","787":"26954e27","829":"c0b4aefe","878":"975db749"}[chunkId] + ".chunk.js";
};